export const PINNED_NAMES = /^(others|n\/a|undisclosed|unknown)$/i

export const COMPOSITION_TABS = [
    { id: 'geo',      label: 'Geography' },
    { id: 'industry', label: 'Industry'  },
    { id: 'stage',    label: 'Stage'     },
]

export const COMPOSITION_NAME_KEYS = {
    geo: 'investedin_location_name',
    industry: 'investedin_industry_name',
    stage: 'investedin_stage_name',
}
